module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-kit",
    attrs: {
      "id": "ui-kit"
    }
  }, [_c('div', {
    staticClass: "title-bar"
  }, [_c('div', {
    staticClass: "title -heading"
  }, [_vm._v("UI KIT")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Style Guide template")]), _vm._v(" "), _c('div', {
    staticClass: "for"
  }, [_vm._v("For Designer and Developer")])])]), _vm._v(" "), _c('pre', [_vm._v("    "), _c('code', {
    staticClass: "language-markup"
  }, [_vm._v("\n      "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("kit-box"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n        "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("name"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("Colors"), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n        "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("description"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("All colors used in project"), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n        "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("component -colors"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n          "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("set-box"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("meaning"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              Positive "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Success "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Approve "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Confirm "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Save "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("color-box"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("color -green"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("code"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("#56BD5B"), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n          "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n          "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("set-box"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("meaning"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              Alert "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Warning "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("color-box"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("color -orange"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("code"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("#F7B422"), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n          "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n          "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("set-box"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("meaning"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              Negative "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Fail "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Cancel "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Delete "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Danger "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("color-box"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("color -red"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("code"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("#E34C4C"), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n          "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n          "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("set-box"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("meaning"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              Active "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Info "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n              Select "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("br")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("/>")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("color-box"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("color -blue"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n              "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("<")]), _vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "token attr-name"
  }, [_vm._v("class")]), _c('span', {
    staticClass: "token attr-value"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("=")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")]), _vm._v("code"), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("\"")])]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("#00C0EF"), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n            "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n          "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n        "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n      "), _c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token tag"
  }, [_c('span', {
    staticClass: "token punctuation"
  }, [_vm._v("</")]), _vm._v("div")]), _c('span', {
    staticClass: "token punctuation"
  }, [_vm._v(">")])]), _vm._v("\n\n    ")]), _vm._v("\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "kit-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All colors used in project")]), _vm._v(" "), _c('div', {
    staticClass: "component -colors"
  }, [_c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "meaning"
  }, [_vm._v("\n          Positive "), _c('br'), _vm._v("\n          Success "), _c('br'), _vm._v("\n          Approve "), _c('br'), _vm._v("\n          Confirm "), _c('br'), _vm._v("\n          Save "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "color-box"
  }, [_c('div', {
    staticClass: "color -green"
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v("#56BD5B")])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "meaning"
  }, [_vm._v("\n          Alert "), _c('br'), _vm._v("\n          Warning "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "color-box"
  }, [_c('div', {
    staticClass: "color -orange"
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v("#F7B422")])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "meaning"
  }, [_vm._v("\n          Negative "), _c('br'), _vm._v("\n          Fail "), _c('br'), _vm._v("\n          Cancel "), _c('br'), _vm._v("\n          Delete "), _c('br'), _vm._v("\n          Danger "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "color-box"
  }, [_c('div', {
    staticClass: "color -red"
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v("#E34C4C")])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "meaning"
  }, [_vm._v("\n          Active "), _c('br'), _vm._v("\n          Info "), _c('br'), _vm._v("\n          Select "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "color-box"
  }, [_c('div', {
    staticClass: "color -blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v("#00C0EF")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "kit-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Type face")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All typeface used in project")]), _vm._v(" "), _c('div', {
    staticClass: "component -typeface"
  }, [_c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "font-name"
  }, [_vm._v("Prompt")]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_vm._v("AaBbCcDd")])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "font-name"
  }, [_vm._v("Prompt")]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_vm._v("กขคงจ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "kit-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All Information about Heading. Paragraph. etc.")]), _vm._v(" "), _c('div', {
    staticClass: "component -typography"
  }, [_c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Heading Text")]), _vm._v(" "), _c('div', [_vm._v("\n            Font-family   : Prompt "), _c('br'), _vm._v("\n            Style Rec.    : Medium "), _c('br'), _vm._v("\n            Font-size     : 24 px  "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example -text-xl"
  }, [_vm._v("\n          The standard Lorem Ipsum passage, used since the 1500s "), _c('br'), _vm._v("\n          ท่อนหนึ่งของ Lorem Ipsum ที่ใช้กันเป็นมาตรฐานมาตั้งแต่ศตวรรษที่ 16 "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Large Text")]), _vm._v(" "), _c('div', [_vm._v("\n            Font-family   : Prompt "), _c('br'), _vm._v("\n            Style Rec.    : Medium "), _c('br'), _vm._v("\n            Font-size     : 18 px  "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example -text-lg"
  }, [_vm._v("\n          ตอนที่ 1.10.32 จาก \"de Finibus Bonorum et Malorum\" เขียนโดย ซิเซโร เมื่อ 45 ปี ก่อนคริตศตวรรษ"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Normal Text")]), _vm._v(" "), _c('div', [_vm._v("\n            Font-family   : Prompt "), _c('br'), _vm._v("\n            Style Rec.    : Light "), _c('br'), _vm._v("\n            Font-size     : 16 px  "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example -text-md"
  }, [_vm._v("\n          Lorem Ipsum คือ เนื้อหาจำลองแบบเรียบๆ ที่ใช้กันในธุรกิจงานพิมพ์หรืองานเรียงพิมพ์ "), _c('br'), _vm._v("\n          มันได้กลายมาเป็นเนื้อหาจำลองมาตรฐานของธุรกิจดังกล่าวมาตั้งแต่ศตวรรษที่ 16 "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Small Text")]), _vm._v(" "), _c('div', [_vm._v("\n            Font-family   : Prompt "), _c('br'), _vm._v("\n            Style Rec.    : Light "), _c('br'), _vm._v("\n            Font-size     : 14 px  "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example -text-sm"
  }, [_vm._v("\n          มีหลักฐานที่เป็นข้อเท็จจริงยืนยันมานานแล้ว ว่าเนื้อหาที่อ่านรู้เรื่องนั้นจะไปกวนสมาธิของคนอ่านให้เขวไปจากส่วนที่เป็น Layout\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Extra Small Text")]), _vm._v(" "), _c('div', [_vm._v("\n            Font-family   : Prompt "), _c('br'), _vm._v("\n            Style Rec.    : Light "), _c('br'), _vm._v("\n            Font-size     : 12 px  "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example -text-xs"
  }, [_vm._v("\n          ฉบับแปลเมื่อปี ค.ศ. 1914 โดย เอช แร็คแคม\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "kit-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Button")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All Information about Button.")]), _vm._v(" "), _c('div', {
    staticClass: "component -button"
  }, [_c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Large Button")]), _vm._v(" "), _c('div', [_vm._v("\n            Font-size     : 18px "), _c('br'), _vm._v("\n            Height        : 45px "), _c('br'), _vm._v("\n            Min-Width     : 110px "), _c('br'), _vm._v("\n            padding       : 10px 16px "), _c('br'), _vm._v("\n            Text-Align    : Center "), _c('br'), _vm._v("\n            Border-Radius : 2px "), _c('br'), _vm._v("\n            Border        : none "), _c('br'), _vm._v("\n            Box-Shadow    : 1px 2px 3px rgba (0,0,0,0.3) "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Regular (Ex. 70)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-lg _bg-green",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Hover (Ex. 80)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-lg -green-hover",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Active (Ex. 80)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-lg -green-hover",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Disable (Ex. 20)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-lg -disable -green-disable",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Normal Button")]), _vm._v(" "), _c('div', [_vm._v("\n            Font-size     : 16px "), _c('br'), _vm._v("\n            Height        : 35px "), _c('br'), _vm._v("\n            Min-Width     : 100px "), _c('br'), _vm._v("\n            padding       : 6px 14px "), _c('br'), _vm._v("\n            Text-Align    : Center "), _c('br'), _vm._v("\n            Border-Radius : 2px "), _c('br'), _vm._v("\n            Border        : none "), _c('br'), _vm._v("\n            Box-Shadow    : 1px 2px 3px rgba (0,0,0,0.3) "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Regular (Ex. 70)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-md _bg-green",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Hover (Ex. 80)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-md -green-hover",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Active (Ex. 80)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-md -green-hover",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Disable (Ex. 20)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-md -disable -green-disable",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Small Button")]), _vm._v(" "), _c('div', [_vm._v("\n            Font-size     : 14px "), _c('br'), _vm._v("\n            Height        : 25px "), _c('br'), _vm._v("\n            Min-Width     : 90px "), _c('br'), _vm._v("\n            padding       : 2px 10px "), _c('br'), _vm._v("\n            Text-Align    : Center "), _c('br'), _vm._v("\n            Border-Radius : 2px "), _c('br'), _vm._v("\n            Border        : none "), _c('br'), _vm._v("\n            Box-Shadow    : 1px 2px 3px rgba (0,0,0,0.3) "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Regular (Ex. 70)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-sm _bg-green",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Hover (Ex. 80)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-sm -green-hover",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Active (Ex. 80)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-sm -green-hover",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])]), _vm._v(" "), _c('div', {
    staticClass: "button-set"
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("Disable (Ex. 20)")]), _vm._v(" "), _c('div', {
    staticClass: "button-box"
  }, [_c('button', {
    staticClass: "button-sm -disable -green-disable",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Buttton")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "kit-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Input Text")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All Information about Input Text.")]), _vm._v(" "), _c('div', {
    staticClass: "component -input"
  }, [_c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Normal Input")]), _vm._v(" "), _c('div', [_vm._v("\n            Height        : 35px "), _c('br'), _vm._v("\n            Min-Width     : 100px "), _c('br'), _vm._v("\n            padding       : 6px "), _c('br'), _vm._v("\n            Border-Radius : 2px "), _c('br'), _vm._v("\n            Label Color   : #B7B7B7 "), _c('br'), _vm._v("\n            Input Color   : #252525 "), _c('br'), _vm._v("\n            Border        : 1px solid #B7B7B7 "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Normal Input")]), _vm._v(" "), _c('input', {
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "name": "input"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Normal Input")]), _vm._v(" "), _c('input', {
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "name": "input",
      "value": "When you start typing"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Icon Input")]), _vm._v(" "), _c('div', [_vm._v("\n            Icon Color   : #B7B7B7 "), _c('br'), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Icon Input")]), _vm._v(" "), _c('input', {
    staticClass: "icon-input",
    attrs: {
      "type": "text",
      "name": "input"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Icon Input")]), _vm._v(" "), _c('input', {
    staticClass: "icon-input",
    attrs: {
      "type": "text",
      "name": "input",
      "value": "When you start typing"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Icon Input")]), _vm._v(" "), _c('input', {
    staticClass: "icon-input",
    attrs: {
      "type": "text",
      "name": "input"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Icon Input")]), _vm._v(" "), _c('input', {
    staticClass: "icon-input",
    attrs: {
      "type": "text",
      "name": "input",
      "value": "01/01/2017"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('br'), _c('br'), _vm._v("Input with unit")]), _vm._v(" "), _c('div', [_vm._v("\n            Unit Color   : #B7B7B7 "), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Icon Input")]), _vm._v(" "), _c('input', {
    staticClass: "unit-input",
    attrs: {
      "type": "text",
      "name": "input"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("Hour")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Icon Input")]), _vm._v(" "), _c('input', {
    staticClass: "unit-input",
    attrs: {
      "type": "text",
      "name": "input",
      "value": "3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("Hours")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('br'), _c('br'), _vm._v("Active Input")]), _vm._v(" "), _c('div', [_vm._v("\n            Border Color   : #00C0CF "), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Active Input")]), _vm._v(" "), _c('input', {
    staticClass: "normal-input -active",
    attrs: {
      "type": "text",
      "name": "input"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Active Input")]), _vm._v(" "), _c('input', {
    staticClass: "normal-input -active",
    attrs: {
      "type": "text",
      "name": "input",
      "value": "When you start typing"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('br'), _c('br'), _vm._v("Success Input")]), _vm._v(" "), _c('div', [_vm._v("\n            Border-Color  : #56BD5B"), _c('br'), _vm._v("\n          Validator Text  : #56BD5B"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Success Input")]), _vm._v(" "), _c('input', {
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "name": "input"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Success Input")]), _vm._v(" "), _c('input', {
    staticClass: "normal-input -success",
    attrs: {
      "type": "text",
      "name": "input",
      "value": "When you start typing"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "validator-text -success"
  }, [_vm._v("Great! This Username is Available.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('br'), _c('br'), _vm._v("Success Input")]), _vm._v(" "), _c('div', [_vm._v("\n            Border-Color  : #E34C4C"), _c('br'), _vm._v("\n          Validator Text  : #E34C4C"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Error Input")]), _vm._v(" "), _c('input', {
    staticClass: "normal-input",
    attrs: {
      "type": "text",
      "name": "input"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Error Input")]), _vm._v(" "), _c('input', {
    staticClass: "normal-input -error",
    attrs: {
      "type": "text",
      "name": "input"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "validator-text -error"
  }, [_vm._v("This is a required field.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('br'), _c('br'), _vm._v("Disable Input")]), _vm._v(" "), _c('div', [_vm._v("\n            Background  : #E1E1E1"), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Disable Input")]), _vm._v(" "), _c('input', {
    staticClass: "normal-input -disable",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "input"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "kit-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Dropdown")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All Information about Dropdown.")]), _vm._v(" "), _c('div', {
    staticClass: "component -dropdown"
  }, [_c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('br'), _c('br'), _vm._v("Dropdown")]), _vm._v(" "), _c('div', [_vm._v("\n            Border Focus        : #00C0Ef "), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "input-set"
  }, [_c('div', {
    staticClass: "dropdown-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Normal")]), _vm._v(" "), _c('select', {
    staticClass: "dropdown"
  }, [_c('option', {
    attrs: {
      "value": "Menu1"
    }
  }, [_vm._v("Menu1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Menu2"
    }
  }, [_vm._v("Menu2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Menu3"
    }
  }, [_vm._v("Menu3")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down caret",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "kit-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Tab Select")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All Information about Tab Select.")]), _vm._v(" "), _c('div', {
    staticClass: "component -tabselect"
  }, [_c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("Tab Select")]), _vm._v(" "), _c('div', [_vm._v("\n            Border-Top  : 2px "), _c('br'), _vm._v("\n            Border-color  : #B7B7B7 "), _c('br'), _vm._v("\n            Unactive Text : #252525"), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "tabselect-set"
  }, [_c('div', {
    staticClass: "topic-ex"
  }, [_vm._v("Tabs Select Example")]), _vm._v(" "), _c('div', {
    staticClass: "tabselect-group"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab1"
    }
  }, [_vm._v("TAB 1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab2"
    }
  }, [_vm._v("TAB 2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab3"
    }
  }, [_vm._v("TAB 3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#tab4"
    }
  }, [_vm._v("TAB 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "tab1"
    }
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed purus sapien, varius nec rutrum quis, fringilla lobortis diam. Suspendisse condimentum dapibus dui id venenatis. Vivamus efficitur ullamcorper tortor a bibendum. In semper lectus tristique commodo gravida. Donec in molestie nisl. Etiam tristique lorem massa, sed pharetra dolor accumsan ac. Aliquam nec sodales diam. Pellentesque vehicula imperdiet lectus eget imperdiet. Nam tristique, tortor non condimentum mattis, ex orci efficitur nulla, ut accumsan justo ante in libero.")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tab2"
    }
  }, [_c('p', [_vm._v("Phasellus faucibus tortor eu lorem tempus pretium. Nunc nec varius tortor, quis porta urna. Ut quis dapibus nisl. Phasellus porta nibh sed mauris vestibulum viverra. Aenean suscipit libero quam, ac viverra justo blandit non. Maecenas ac nunc a velit consequat interdum vitae nec nisl. Vivamus et arcu ut nisl tincidunt pretium nec id nisi. Proin consectetur volutpat turpis, quis convallis sapien scelerisque nec. Quisque purus velit, ultrices a rutrum ut, gravida a augue. Sed vestibulum consequat ipsum, sed aliquam felis auctor vitae. Pellentesque consectetur sem in dignissim semper. Aliquam a consectetur ex. Duis sollicitudin semper est eget finibus. Donec ultrices diam at pellentesque aliquam. Nullam molestie arcu eros, eget tempus enim pretium in. Donec ut nisi convallis, molestie sem non, interdum est.")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tab3"
    }
  }, [_c('p', [_vm._v("Donec placerat nulla nec nisl ultrices suscipit. Donec magna nulla, pharetra in egestas at, efficitur ut leo. Morbi volutpat aliquam ipsum sed interdum. Aenean sodales ut ligula quis faucibus. Fusce rutrum rutrum orci, non mollis elit vestibulum nec. Maecenas porta eu sem quis luctus. Mauris sit amet purus interdum, mollis justo at, consectetur enim. Curabitur feugiat erat risus, et eleifend felis posuere aliquet. Vestibulum euismod tellus non dui dignissim tempus.")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tab4"
    }
  }, [_c('p', [_vm._v("Curabitur quis lorem id odio pharetra varius sit amet quis nunc. Fusce porta ipsum leo, non eleifend tellus pulvinar non. Integer imperdiet tortor elit, vitae sagittis magna fermentum et. ")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "kit-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Expand Tabs")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("All Information about Expand Tabs.")]), _vm._v(" "), _c('div', {
    staticClass: "component -expandtabs"
  }, [_c('div', {
    staticClass: "set-box"
  }, [_c('div', {
    staticClass: "detail-box"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('br'), _c('br'), _vm._v("Expand Tabs")]), _vm._v(" "), _c('div', [_vm._v("\n            Border-Top    : 2px "), _c('br'), _vm._v("\n            Border Color  : #B7B7B7 "), _c('br'), _vm._v("\n            Padding Head  : 14px "), _c('br'), _vm._v("\n            Padding Body  : 25px "), _c('br'), _vm._v("\n            Height        : 60px "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('div', {
    staticClass: "expandtabs-set"
  }, [_c('div', {
    staticClass: "expandtabs-group"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n                      Collapsible Group 1\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit,\n                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad\n                    minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea\n                    commodo consequat.")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33a4115f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/styleGuide/backup.vue
// module id = 3676
// module chunks = 1